import { useState, useEffect } from "react"
import Image from "next/legacy/image"
import Link from "next/link"
import { useMediaPredicate } from "react-media-hook"
import { usePropsObject } from "@/lib/contexts/appContext"
import HeadingLabel from "@/common/partials/headingLabel/headingLabel"
import Block from "@/components/wrappers/block"
import { Information } from "./event-info"
import styles from "./calendar-single.module.css"
import classNames from "classnames"

export default function EventContent({ block, settings }) {
  const { heading, image, lead, type, content } = block.attrs
  const object = usePropsObject()

  const isMobile = useMediaPredicate("(max-width: 420px)")
  const [hasMounted, setMounted] = useState(false)

  // This is used due to isMobile not working before mount
  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      setMounted(true)
    }
    return () => {
      isMounted = false
    }
  }, [])

  return (
    <Block width="bleed" gap="small" block={block} className="content-wrapper">
      <figure className={classNames({ "has-caption": image?.credit })}>
        {image && (
          <Image
            src={image.url}
            sizes={image.sizes}
            layout="fill"
            objectFit="cover"
          />
        )}
        {image?.credit && <figcaption>Bild: {image.credit}</figcaption>}
      </figure>
      <AvailableSeats settings={settings} />
      {type.name && (
        <HeadingLabel className="type">
          {type.url && (
            <Link href={type.url} prefetch={false}>
              {type.name}
            </Link>
          )}
          {!type.url && <span>{type.name}</span>}
        </HeadingLabel>
      )}
      <h1>{heading}</h1>
      {hasMounted && isMobile && (
        <div className={classNames(styles.info, "information")}>
          <Information object={object} renderButton={false} />
        </div>
      )}
      {lead && <p className="lead">{lead}</p>}
      <div className="body" dangerouslySetInnerHTML={{ __html: content }} />
    </Block>
  )
}

const AvailableSeats = ({ settings }) => {
  if (!settings?.haveSeats) {
    return null
  }

  if (!settings.loading && !settings.seats) {
    return null
  }

  const text = settings.loading ? "Laddar" : settings.seats + " Lediga platser"

  return (
    <div
      className={classNames("available-seats", {
        "is-loading": settings.loading
      })}>
      <span className="dot"></span>
      {text}
    </div>
  )
}
